import React, { SyntheticEvent, useState } from 'react';
import { Trans } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import PrimaryButton from 'commons/src/components/buttons/PrimaryButton';
import ResponseBox from 'commons/src/components/responseMessages/ResponseBox';
import { linkToAirthingsAfBReadme, linkToApiDocs } from 'commons/src/constants';
import { ErrorType } from 'commons/src/models/commonTypeScript';
import { setSegmentLabels } from '../../../actions/segmentPropertiesActions';
import { KeyValuePairType } from '../../../models/common';
import { Store } from '../../../reducers';
import { BusinessRequestType as RequestType } from '../../../reducers/BusinessRequestType';
import MapInput, { pairsWithError } from '../../integrations/webhooks/MapInput';

type StateProps = {
    segmentLabels: {
        [serialNumber: string]: KeyValuePairType[];
    };
    loading: boolean;
    error?: ErrorType;
};

type PassedProps = {
    serialNumber: string;
    goBack: (e: SyntheticEvent<HTMLElement>) => void;
};

export type Props = PassedProps & StateProps;

export const DeviceLabelsComponent = ({
    segmentLabels,
    goBack,
    error,
    loading,
    serialNumber,
}: Props): React.ReactElement => {
    const [labels, setLabels] = useState(segmentLabels[serialNumber] || []);
    const [displayValidation, setDisplayValidation] = useState(false);
    const dispatch = useDispatch();

    const updateLabels = (updatedLabels: KeyValuePairType[]): void => {
        setLabels(updatedLabels);
    };

    const saveSegmentLabels = (): void => {
        const errorInLabels = pairsWithError(labels);
        if (errorInLabels) {
            setDisplayValidation(true);
        } else {
            setDisplayValidation(false);
            dispatch(setSegmentLabels(serialNumber, labels));
        }
    };

    return (
        <div className="page-wrapper__inner page-wrapper__inner--slim">
            <form className="change-location__form">
                <p>
                    <Trans i18nKey="CustomLabels.CustomLabelsDescription" values={{ link: linkToAirthingsAfBReadme }}>
                        <a href={linkToApiDocs} target="_blank" rel="noopener noreferrer">
                            {linkToAirthingsAfBReadme}
                        </a>
                    </Trans>
                </p>
                <div className="change-location__form__labels">
                    <MapInput
                        id="segment-labels-selector"
                        updatePair={updateLabels}
                        pairs={labels}
                        displayValidation={displayValidation}
                        keyHeader="CustomLabels.LabelKey"
                        keyHint="CustomLabels.LabelKeyRequiredHint"
                        valueHeader="CustomLabels.LabelValue"
                        valueHint=""
                        addButtonText="CustomLabels.AddLabel"
                        maxValueLength={255}
                        maxKeyLength={255}
                        maxRows={20}
                    />
                </div>
                {error && <ResponseBox text={`ErrorCodes.${error.error}`} />}
                <div className="change-location__form__buttons">
                    <PrimaryButton color="secondary" id="close" title="Close" loading={false} onClick={goBack} />
                    <PrimaryButton
                        id="submit"
                        type="button"
                        title="SaveChanges"
                        color="primary"
                        loading={loading}
                        onClick={saveSegmentLabels}
                    />
                </div>
            </form>
        </div>
    );
};

const mapStateToProps = (state: Store): StateProps => {
    const {
        segmentPropertiesStore: { segmentLabels },
        requests: {
            [RequestType.UpdateSegmentLabels]: { loading, error },
        },
    } = state;

    return {
        segmentLabels,
        loading,
        error,
    };
};

export default connect(mapStateToProps)(DeviceLabelsComponent);
